import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {PiEyeSlashFill} from 'react-icons/pi'

export const AdminOnlyNotice = ({className = ''}) => {
    const t = useTranslate()
    return (
        <div
            className={classNames(
                'flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-amber-50 text-amber-700',
                className,
            )}>
            <PiEyeSlashFill size={13} className="flex-shrink-0"/>
            <span className="text-xs font-medium italic tracking-wide leading-snug">
                {t('admin only notice')}
            </span>
        </div>
    )
}

export default AdminOnlyNotice
